import styled from "styled-components";

import { transparentize } from "polished";

export const Barline = styled.div`
    position: absolute;
    top: 0;
    width: 20px;
    margin-left: -10px;
    background: linear-gradient(-90deg, transparent, ${p => transparentize(1 - 0.8, p.theme.c.active)}, transparent);
    cursor: pointer;
`;

export const In = styled.div`
    width: 2px;
    background-color: ${p => p.theme.c.boost};
    height: 100%;
    margin-left: 9px;
`;
